<template>
  <group-card :title="autoDurationMandationService.generated_entry ? 'Previous Employment': 'Not Required'" icon="work">
    <draggable
      v-model="display_employments"
      handle=".handle"
      group="employments"
      ghostClass="draggable-ghost-class"
      class="md-layout-item"
      :move="allowDraggableMove"
    >
      <!-- <transition-group v-bind="transitions.expand"> -->

      <!-- Employment array inputs -->
      <list-item-card v-for="(employment, index) in display_employments" :key="id(employment)">
        <template slot="title">
          Previous Employment {{ index + 1 }}
          <em v-if="employment == generated_employment">
            <b
              >&nbsp;Generated ({{ autoDurationMandationService.target_months }} months required)</b
            >
          </em>
        </template>

        <template slot="actions">
          <md-icon class="handle" v-if="employment != generated_employment">menu</md-icon>
          <md-button
            class="md-just-icon md-danger md-simple"
            @click="removeListItem(employment)"
            :disabled="employment == generated_employment"
            ><md-icon>close</md-icon></md-button
          >
        </template>

        <edit-applicant-employment
          :value="employment"
          :applicant="applicant"
          previous
          @change="notifyEmploymentUpdate(employment)"
          @application-change="applicationChange"
          :prefixLabel="prefixLabel + ' ' + (index+1)"
        />
      </list-item-card>

      <!-- </transition-group> -->
    </draggable>

    <!-- Add -->
    <div class="md-layout-item">
      <md-button class="md-primary md-sm" @click="addListItem">Add</md-button>
    </div>
  </group-card>
</template>

<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import utils from "@/components/utils/utils";
import transitions from "@/components/utils/transitions";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import GroupCardRow from "@/components/Cards/GroupCardRow";
import ListItemCard from "@/components/Cards/ListItemCard.vue";
import EditApplicantEmployment from "@/components/Editors/EditApplicantEmployment";
import draggable from "vuedraggable";
import { newEmployment } from "@/schema.js";

export default {
  components: {
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    ListItemCard,
    EditApplicantEmployment,
    draggable,
  },
  data() {
    return {
      transitions,
      auto_duration_mandation_service_source: null,
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    autoDurationMandationService: {
      default: null,
    },
    prefixLabel: {
      type: String,
      default: "",
    },
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: "options",
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get() {
        return this.value;
      },
      set(applicant) {
        this.$emit("input", applicant);
      },
    },
    generated_employment() {
      return this.autoDurationMandationService && this.autoDurationMandationService.generated_entry;
    },
    display_employments: {
      get() {
        return this.auto_duration_mandation_service_source.get();
      },
      set(employments) {
        this.applicant.employments.previous = this.auto_duration_mandation_service_source.set(
          employments
        );
      },
    },
  },
  watch: {
    "value.employments.previous"() {
      if (this.auto_duration_mandation_service_source) {
        this.auto_duration_mandation_service_source.notifyChange(this.value.employments.previous);
      }
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    addListItem() {
      this.applicant.employments.previous.push(newEmployment());
    },
    applicationChange() {
      this.$emit('application-change')
      this.loading = false;
    },
    removeListItem(employment) {
      this.arrayRemove(this.applicant.employments.previous, employment);
    },
    notifyEmploymentUpdate(employment = null) {
      if (this.autoDurationMandationService && employment.duration.months !== null && employment.duration.years !== null) {
        this.autoDurationMandationService.update(employment);
      }
    },
    makeTemporaryEmploymentPermanent(employment) {
      this.applicant.employments.previous.push(employment);
    },

    onCreateTemporaryEntry() {
      let employment = newEmployment();
      this.applicant.employments.previous.push(employment);
      return employment;
    },
    onRemoveTemporaryEntry(employment) {
      this.arrayRemove(this.applicant.employments.previous, employment);
    },
    allowDraggableMove(event) {
      let target_employments = event.relatedContext.element;
      let generated_employments = this.autoDurationMandationService.generated_entry;
      return target_employments != generated_employments;
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  created() {
    if (this.autoDurationMandationService) {
      this.auto_duration_mandation_service_source = new this.autoDurationMandationService.Source(
        this.applicant.employments.previous,
        (employment) => employment.duration,
        "sum",
        true
      );

      this.autoDurationMandationService.createTemporaryEntry = () => newEmployment();
      this.autoDurationMandationService.makeTemporaryEntryPermanent = this.makeTemporaryEmploymentPermanent;
      this.autoDurationMandationService.registerSource(this.auto_duration_mandation_service_source);
      this.autoDurationMandationService.update();
    }
  },
};
</script>
